import { render, staticRenderFns } from "./PublicFeedbackBlock.vue?vue&type=template&id=90c78b8c&scoped=true&"
import script from "./PublicFeedbackBlock.vue?vue&type=script&lang=js&"
export * from "./PublicFeedbackBlock.vue?vue&type=script&lang=js&"
import style0 from "./PublicFeedbackBlock.vue?vue&type=style&index=0&id=90c78b8c&prod&lang=css&"
import style1 from "./PublicFeedbackBlock.vue?vue&type=style&index=1&id=90c78b8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c78b8c",
  null
  
)

export default component.exports